import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

export default function Splash() {
  const navigate = useNavigate();
  const { status } = useAuth();

  useEffect(() => {
    const minDuration = 1300;
    const start = Date.now();

    const timer = setInterval(() => {
      if (status === "loading") return;
      const elapsed = Date.now() - start;
      if (elapsed < minDuration) return;
      clearInterval(timer);
      navigate(status === "authenticated" ? "/home" : "/login", { replace: true });
    }, 100);

    return () => clearInterval(timer);
  }, [status, navigate]);

  return (
    <div
      className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden"
      style={{
        background:
          "radial-gradient(circle at 50% 35%, #EFF6FF 0%, #FFFFFF 65%)",
      }}
      data-testid="splash-screen"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.92 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className="relative"
      >
        <div
          className="relative flex items-center justify-center"
          style={{ width: 240, height: 240 }}
          data-testid="splash-ring-wrap"
        >
          {/* Anneaux pulsants encadrent le bloc complet (logo full carré) */}
          <span className="sa-splash-ring sa-splash-ring--light" />
          <span className="sa-splash-ring sa-splash-ring--light sa-splash-ring-delay" />
          <Logo size={240} />
        </div>
      </motion.div>

      {/* Tagline discrète — le logo contient déjà le texte "SignalAgent". */}
      <motion.p
        initial={{ opacity: 0, y: 6 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.45, ease: "easeOut" }}
        className="mt-6 text-[13px] font-medium text-slate-500"
      >
        Sécurité des agents immobiliers
      </motion.p>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.85 }}
        className="absolute bottom-8 text-xs font-medium text-slate-400"
        data-testid="splash-footer"
      >
        Propulsé par C l'Agence
      </motion.p>
    </div>
  );
}
